<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Modifier un Service</h4>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <div class="page-btn">
              <router-link to="/services" class="btn btn-secondary"
                ><vue-feather type="arrow-left" class="me-2"></vue-feather
                >Retourner vers les Service</router-link
              >
            </div>
          </li>
          <li>
            <a
              ref="collapseHeader"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Collapse"
              @click="toggleCollapse"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
      </div>
      <!-- /add -->
      <form @submit.prevent="submitForm">
        <div class="card">
          <div class="card-body add-product pb-0">
            <div class="accordion-card-one accordion" id="accordionExample">
              <div class="accordion-item">
                <div class="accordion-header" id="headingOne">
                  <div
                    class="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-controls="collapseOne"
                  >
                    <div class="addproduct-icon">
                      <h5>
                        <vue-feather type="info" class="add-info"></vue-feather
                        ><span>Informations du Service</span>
                      </h5>
                      <a href="javascript:void(0);"
                        ><vue-feather
                          type="chevron-down"
                          class="chevron-down-add"
                        ></vue-feather
                      ></a>
                    </div>
                  </div>
                </div>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <div class="row">
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Nom de Service</label>
                          <input
                            v-model="form.nom"
                            type="text"
                            class="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="input-blocks add-product list">
                          <label>Référence</label>
                          <input
                            type="text"
                            class="form-control list"
                            placeholder="Enter SKU"
                            v-model="form.reference_service"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="input-blocks add-product list">
                          <label>Durée de Jours</label>
                          <input
                            type="number"
                            min="0"
                            class="form-control list"
                            placeholder="Enter SKU"
                            v-model="form.duree_jours"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div class="add-product-new">
                      <div class="row">
                        <div class="col-lg-4 col-sm-6 col-12">
                          <div class="mb-3 add-product">
                            <label class="form-label">Catégorie</label>
                            <vue-select
                              id="sellingtypess"
                              placeholder="Choose"
                              :options="categoryData"
                              :reduce="(option) => categoryData.indexOf(option)"
                              v-model="selectedCategory"
                            />
                          </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 col-12">
                          <div class="mb-3 add-product">
                            <label class="form-label">Statut d'achat</label>
                            <div class="d-flex gap-3 mt-2">
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="statut_achat"
                                  id="achat_actif"
                                  :value="true"
                                  v-model="form.statut_achat"
                                  style="height: 1rem !important"
                                />
                                <label
                                  class="form-check-label"
                                  for="achat_actif"
                                >
                                  Actif
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="statut_achat"
                                  id="achat_inactif"
                                  :value="false"
                                  v-model="form.statut_achat"
                                  style="height: 1rem !important"
                                />
                                <label
                                  class="form-check-label"
                                  for="achat_inactif"
                                >
                                  Inactif
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 col-12">
                          <div class="mb-3 add-product">
                            <label class="form-label">Statut de Vente</label>
                            <div class="d-flex gap-3 mt-2">
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="statut_vente"
                                  id="vente_actif"
                                  :value="true"
                                  v-model="form.statut_vente"
                                  style="height: 1rem !important"
                                />
                                <label
                                  class="form-check-label"
                                  for="vente_actif"
                                >
                                  Actif
                                </label>
                              </div>
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="statut_vente"
                                  id="vente_inactif"
                                  :value="false"
                                  v-model="form.statut_vente"
                                  style="height: 1rem !important"
                                />
                                <label
                                  class="form-check-label"
                                  for="vente_inactif"
                                >
                                  Inactif
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Editor -->
                    <div class="col-lg-12">
                      <div
                        class="input-blocks summer-description-box transfer mb-3"
                      >
                        <label>Description</label>
                        <textarea
                          v-model="form.description"
                          class="form-control h-100"
                          rows="5"
                          required
                        ></textarea>
                        <p class="mt-1">Maximum 60 Characters</p>
                      </div>
                    </div>
                    <!-- /Editor -->
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion-card-one accordion" id="accordionExample2">
              <div class="accordion-item">
                <div class="accordion-header" id="headingTwo">
                  <div
                    class="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-controls="collapseTwo"
                  >
                    <div class="text-editor add-list">
                      <div class="addproduct-icon list icon">
                        <h5>
                          <vue-feather
                            type="life-buoy"
                            class="add-info"
                          ></vue-feather
                          ><span>Prix </span>
                        </h5>
                        <a href="javascript:void(0);"
                          ><vue-feather
                            type="chevron-down"
                            class="chevron-down-add"
                          ></vue-feather
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample2"
                >
                  <div class="accordion-body">
                    <div class="tab-content" id="pills-tabContent">
                      <div
                        class="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        <div class="row">
                          <div class="col-lg-4 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Prix d'achat</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                value="20"
                                class="form-control"
                                v-model="form.prix_achat"
                                required
                              />
                            </div>
                          </div>
                          <div class="col-lg-4 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Prix de Vente</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                class="form-control"
                                v-model="form.prix_vente"
                                required
                              />
                            </div>
                          </div>
                          <div class="col-lg-4 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Prix de Vente Minimum</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                class="form-control"
                                v-model="form.prix_vente_minimum"
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-body">
                    <div class="tab-content" id="pills-tabContent">
                      <div
                        class="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        <div class="row">
                          <div class="col-lg-4 col-sm-6 col-12">
                            <div class="input-blocks add-product">
                              <label>Taux TVA</label>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                value="20"
                                class="form-control"
                                v-model="form.taux_taxe"
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="btn-addproduct mb-4">
            <button type="button" class="btn btn-cancel me-2">Annuler</button>
            <button type="submit" class="btn btn-submit">Modifier</button>
          </div>
        </div>
      </form>
      <!-- /add -->
    </div>
  </div>
  <add-product-modal></add-product-modal>
</template>
<script>
import { ref } from "vue";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
import Swal from "sweetalert2";
import { getCategoriesData, updateService } from "@/services/productsService";
import { toast } from "vue3-toastify";
const categoryData = [];
const categoryIds = [];
export default {
  components: {},

  data() {
    return {
      form: {
        id: null,
        societe_id: null,
        categorie_id: null,
        description: "",
        duree_jours: "",
        prix_vente_minimum: "",
        nom: "",
        statut_achat: null,
        reference_service: "",
        prix_vente: "",
        statut_vente: null,
        taux_taxe: null,
        prix_achat: null,
      },
      isVisible: true,
      isVisible1: true,
      Distype: ["Choose", "Percentage", "Cash"],
      VariantChoose: ["Choose", "Color", "Red", "Black"],
      ChooseTypeDis: ["Choose", "Percentage", "Cash"],
      ExclusiveType: ["Exclusive", "Sales Tax"],
      ChooseCode: ["Choose", "Code34", "Code35", "Code36"],
      SellingType: ["Choose", "Transactional selling", "Solution selling"],
      ChooseAddNew: ["Choose", "Kg", "Pc"],
      ChooseAdd: ["Choose", "Nike", "Bolt"],
      SubSubCategory: ["Choose", "Fruits", "Computers", "Shoes"],
      SubCategory: ["Choose", "Lenovo", "Electronics"],
      ChooseNew: ["Choose", "Lenovo", "Electronics"],
      WarhouseStore: ["Choose", "Legendary", "Determined", "Sincere"],
      ThomasStore: ["Choose", "Thomas", "Rasmussen", "Fred john"],
      tags: ["red", "black"],
      salesStatus: ["Actif", "Inactif"],
      startdate: currentDate,
      startdateOne: currentDateOne,
      dateFormat: "dd-MM-yyyy",
      selectedCategory: "",
      categoryData,
      categoryIds,
    };
  },
  methods: {
    hideProduct() {
      this.isVisible = false;
    },
    hideProduct1() {
      this.isVisible1 = false;
    },
    showConfirmation() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            confirmButtonClass: "btn btn-success",
          });
        }
      });
    },
    toggleCollapse() {
      const collapseHeader = this.$refs.collapseHeader;

      if (collapseHeader) {
        collapseHeader.classList.toggle("active");
        document.body.classList.toggle("header-collapse");
      }
    },
    async getCategoriesData() {
      this.categoryData = [];
      this.categoryIds = [];
      if (localStorage.getItem("categories") != null) {
        const data = JSON.parse(localStorage.getItem("categories"));
        data.map((m) => {
          this.categoryData.push(m.name);
          this.categoryIds.push(m.id);
        });
      } else {
        try {
          const data = await getCategoriesData();
          data.map((m) => {
            this.categoryData.push(m.name);
            this.categoryIds.push(m.id);
          });
        } catch (error) {
          console.error(error);
          toast.error(error.response.data.message);
          toast.error(error.response.data.error);
        }
      }
    },
    geCategoryId(option) {
      let index = this.categoryData.indexOf(option);
      if (index != -1) {
        return this.categoryIds[index];
      }
      return index;
    },

    async submitForm() {
      this.form.categorie_id = this.geCategoryId(this.selectedCategory);
      try {
        const response = await updateService(this.form.id, {
          societe_id: this.form.societe_id,
          nom: this.form.nom,
          description: this.form.description,
          duree_jours: this.form.duree_jours,
          prix_vente_minimum: this.form.prix_vente_minimum,
          prix_vente: this.form.prix_vente,
          reference_service: this.form.reference_service,
          statut_achat: this.form.statut_achat ? 1 : 0,
          statut_vente: this.form.statut_vente ? 1 : 0,
          taux_taxe: this.form.taux_taxe,
          categorie_id: this.form.categorie_id,
        });

        if (localStorage.getItem("services") != null) {
          let services = JSON.parse(localStorage.getItem("services"));
          services.map((service) => {
            if (service.id == response.id) {
              service.societe_id = response.societe_id;
              service.nom = response.nom;
              service.description = response.description;
              service.duree_jours = response.duree_jours;
              service.prix_vente_minimum = response.prix_vente_minimum;
              service.prix_vente = response.prix_vente;
              service.reference_service = response.reference_service;
              service.statut_achat = response.statut_achat;
              service.statut_vente = response.statut_vente;
              service.taux_taxe = response.taux_taxe;
              service.categorie_id = response.categorie_id;
              service.categorie.id = response.categorie_id;
              service.categorie.name = this.selectedCategory;
            }
          });
          const jsonData = JSON.stringify(services);
          localStorage.setItem("services", jsonData);
        }
        if (localStorage.getItem("service") != null) {
          let service = {
            id: response.id,
            societe_id: response.societe_id,
            nom: response.nom,
            description: response.description,
            duree_jours: response.duree_jours,
            prix_vente_minimum: response.prix_vente_minimum,
            prix_vente: response.prix_vente,
            reference_service: response.reference_service,
            statut_achat: response.statut_achat,
            statut_vente: response.statut_vente,
            taux_taxe: response.taux_taxe,
            categorie_id: response.categorie_id,
            categorie: {
              id: response.categorie_id,
              name: this.selectedCategory,
            },
          };
          localStorage.setItem("service", JSON.stringify(service));
        }
        Swal.fire({
          icon: "success",
          title: "Succès",
          text: "Service modifié avec succès.",
          confirmButtonClass: "btn btn-success",
        }).then(() => {
          this.$router.push("/services/");
        });
      } catch (error) {
        console.error(error);
        toast.error(error.response.data.message);
        toast.error(error.response.data.error);
      }
    },
  },
  async mounted() {
    if (localStorage.getItem("service") != null) {
      let service = JSON.parse(localStorage.getItem("service"));
      this.form.id = service.id;
      this.form.societe_id = service.societe_id;
      this.form.categorie_id = service.categorie_id;
      this.form.description = service.description;
      this.form.duree_jours = service.duree_jours;
      this.form.prix_vente_minimum = service.prix_vente_minimum;
      this.form.nom = service.nom;
      this.form.statut_achat = service.statut_achat;
      this.form.reference_service = service.reference_service;
      this.form.prix_vente = service.prix_vente;
      this.form.prix_achat = service.prix_achat;
      this.form.statut_vente = service.statut_vente;
      this.form.taux_taxe = service.taux_taxe;
      this.selectedCategory = service.categorie_nom;

      this.form.statut_achat == 1
        ? (this.form.statut_achat = true)
        : (this.form.statut_achat = false);
      this.form.statut_vente == 1
        ? (this.form.statut_vente = true)
        : (this.form.statut_vente = false);
    }

    await this.getCategoriesData();
  },
};
</script>
